import { Col, Row } from 'antd-v5';
import { useTranslation } from 'react-i18next';
import EtTag from '../eqCustom/EtTag/EtTag';
import { EqNotificationActivityType, EqNotificationType } from '../../components/shared/enums';
import { INotificationItem } from '../NotificationSection/NotificationSection';


interface NotificationItemProps {
    notification: INotificationItem;
    onClick: (notification: any) => void;
}


const NotificationItem = ({ notification, onClick }:NotificationItemProps) => {
  const { t } = useTranslation();

//   const message = t(notification.messageTemplate, {senderName:notification.senderName});

// Dynamically replace placeholders in the message template
const message = t(notification.messageTemplate, {
    senderName: notification.senderName,
    activityType: t(EqNotificationActivityType[notification.activityType]), 
    activityName: notification.activityName,
  });

  return (
  

<div className="notification-popover-item">
<Row key={notification.id}
 className={
  notification.isRead
  ? "notification-read"
  : "notification-unread"
}
    onClick={() => {
    onClick(notification);
    }}
>
  <Col span={24} >
    <Row>
        {/* {notification.titleTemplate} */}
        {/* {EqNotificationActivityType[notification.activityType] +" "+ t(EqNotificationType[notification.notificationType])} */}
       <EtTag>
        {EqNotificationType[notification.notificationType]}
        </EtTag> 
    </Row>
    <Row>
    {/* <p> {t(message)} {t(EqNotificationActivityType[notification.activityType])} {notification.activityName}</p> */}
    <p>{message}</p>
    </Row>
  </Col>
</Row>
</div>

  );
};

export default NotificationItem;
